import i18n from '@/i18n'
import store from '@/store'

export default [
  {
    path: '/business',
    component: () => import(/* webpackChunkName: "business" */ '@/views/Business.vue'),
    props: (route) => ({ ...route.params }),
    meta: {
      permissions: ['Mapi.Business.Read'],
      menu: {
        index: 60,
        activeWhen: ['businessesOverview', 'businessDetail', 'merchantsOverview', 'merchantDetail', 'pricingPlan', 'merchantAccountsOverview', 'merchantAccountDetail', 'businessAccountsOverview', 'businessAccountDetail'],
        title: i18n.t('label.yourBusiness'),
        icon: ['fal', 'briefcase'],
        hasSelectedContext: ['business']
      }
    },
    children: [
      {
        path: '',
        name: 'businessesOverview',
        redirect: { name: 'notFound' }
        // component: () => import(/* webpackChunkName: "business" */ '@/components/Business/Overview/BusinessesOverview.vue'),
        // meta: {
        //   permissions: ['Mapi.Businesses.Read'],
        //   menu: {
        //     routeName: 'businessesOverview',
        //     activeWhen: ['businessesOverview'],
        //     title: 'Businesses'
        //   }
        // }
      },
      {
        path: ':businessId',
        name: 'businessDetail',
        component: () => import(/* webpackChunkName: "business" */ '@/components/Business/Detail/BusinessDetail.vue'),
        meta: {
          permissions: ['Mapi.Business.Read'],
          menu: {
            routeName: 'businessDetail',
            routeParams: context => context.isSelected('business') ? ({ 'businessId': context.business.id }) : {},
            activeWhen: ['businessDetail', 'merchantsOverview'],
            title: i18n.t('label.businessDetails'),
            canShow: ({ context, policy }) => policy.hasAnyBusinessRole(context),
            hasSelectedContext: ['business']
          }
        },
        props: true
      },
      {
        path: ':businessId/merchants',
        name: 'merchantsOverview',
        redirect: { name: 'notFound' }
        // component: () => import(/* webpackChunkName: "business" */ '@/components/Business/Overview/MerchantsOverview.vue'),
        // meta: {
        //   permissions: ['Mapi.Merchants.Read']
        // },
        // props: true
      },
      {
        path: ':businessId/merchants/:merchantId',
        name: 'merchantDetail',
        component: () => import(/* webpackChunkName: "business" */ '@/components/Business/Detail/MerchantDetail.vue'),
        meta: {
          permissions: ['Mapi.Merchant.Read'],
          menu: {
            index: 61,
            routeName: 'merchantDetail',
            routeParams: context => context.isSelected('merchant') ? ({ 'businessId': context.business.id, 'merchantId': context.merchant.id }) : {},
            activeWhen: ['merchantDetail'],
            title: i18n.t('label.merchantDetails'),
            canShow: ({ context, policy }) => policy.hasAnyMerchantRole(context),
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: true
      },
      {
        path: ':businessId/pricing-plan',
        name: 'pricingPlan',
        component: () => import(/* webpackChunkName: "business" */ '@/components/Business/Overview/PricingPlanOverview.vue'),
        meta: {
          permissions: ['Mapi.GatewayFees.Read', 'Mapi.MerchantAccountGroups.Read', 'Mapi.MerchantAccountPricingPlan.Read'],
          menu: {
            routeName: 'pricingPlan',
            routeParams: context => context.isSelected('business') ? ({ 'businessId': context.business.id }) : {},
            activeWhen: ['pricingPlan'],
            title: i18n.t('label.pricingPlan'),
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: true
      },
      {
        path: ':businessId/merchants/:merchantId/merchant-accounts-overview',
        name: 'merchantAccountsOverview',
        component: () => import(/* webpackChunkName: "business" */ '@/components/Business/Overview/MerchantAccountsOverview.vue'),
        meta: {
          permissions: ['Mapi.Beneficiary.Read'],
          menu: {
            routeName: 'merchantAccountsOverview',
            routeParams: context => context.isSelected('merchant') ? ({ 'businessId': context.business.id, 'merchantId': context.merchant.id }) : {},
            activeWhen: ['merchantAccountsOverview', 'merchantAccountDetail'],
            title: i18n.t('label.merchantAccountsOverview'),
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: true
      },
      {
        path: ':businessId/merchants/:merchantId/merchant-accounts-overview/:merchantAccountId',
        name: 'merchantAccountDetail',
        component: () => import(/* webpackChunkName: "business" */ '@/components/Business/Detail/MerchantAccountDetail.vue'),
        meta: {
          permissions: ['Mapi.Beneficiary.Read']
        },
        props: true
      },
      {
        path: ':businessId/merchants/:merchantId/business-accounts-overview',
        name: 'businessAccountsOverview',
        component: () => import(/* webpackChunkName: "business" */ '@/components/Business/Overview/BusinessAccountsOverview.vue'),
        meta: {
          permissions: ['Mapi.Beneficiary.Read'],
          menu: {
            routeName: 'businessAccountsOverview',
            routeParams: context => context.isSelected('merchant') ? ({ 'businessId': context.business.id, 'merchantId': context.merchant.id }) : {},
            activeWhen: ['businessAccountsOverview', 'businessAccountDetail'],
            title: i18n.t('label.businessAccountsOverview'),
            hasSelectedContext: ['business', 'merchant'],
            canShow: ({ context }) => {
              // Ensure we have the full business from Vuex
              const fullBusiness = store.getters.business(context.business?.id || context.business?.businessId)

              if (!fullBusiness) {
                return false
              }

              if (fullBusiness.camAutoRemittance === undefined) {
                return false
              }

              return !fullBusiness.camAutoRemittance
            }
          }
        },
        props: true
      },
      {
        path: ':businessId/merchants/:merchantId/business-accounts-overview/:businessAccountId(\\d+)',
        name: 'businessAccountDetail',
        component: () => import(/* webpackChunkName: "business" */ '@/components/Business/Detail/BusinessAccountDetail.vue'),
        meta: {
          permissions: ['Mapi.Beneficiary.Read'],
          canShow: ({ context }) => {
            // Ensure we have the full business from Vuex
            const fullBusiness = store.getters.business(context.business?.id || context.business?.businessId)

            if (!fullBusiness) {
              return false
            }

            if (fullBusiness.camAutoRemittance === undefined) {
              return false
            }

            return !fullBusiness.camAutoRemittance
          }
        },
        props: true
      }
    ]
  }
]
